export default {
	"b7f9981a0732c25f67ccd4f76a90a08e": "Click to play the video for promotion"
}
